export const type = 'clickMenuLateral';

const clickMenuLateral = (text) => ({
    type,
    payload: new Date(),
    accion:text
});

export default clickMenuLateral;